/* Calabasas — instant search overlay (t29, 2026-09-23)
   Opens from any [data-lv-search-open]; results as you type from Shopify's
   native predictive search endpoint. No app, no dependencies. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-lv-search]');
    if (!root || root.dataset.lvInit) return;
    root.dataset.lvInit = '1';

    var form = root.querySelector('[data-lv-search-form]');
    var input = root.querySelector('[data-lv-search-input]');
    var clearBtn = root.querySelector('[data-lv-search-clear]');
    var body = root.querySelector('[data-lv-search-body]');
    var idle = root.querySelector('[data-lv-search-idle]');
    var out = root.querySelector('[data-lv-search-results]');
    var suggestUrl = (root.dataset.suggestUrl || '/search/suggest') + '.json';
    var searchUrl = root.dataset.searchUrl || '/search';

    // Collections that exist for internal plumbing and must never show to shoppers.
    var HIDDEN_COLLECTION = /internal|do-not-delete|gift-engine|^frontpage$|^all$/i;

    var cache = {};
    var ctrl = null;
    var timer = null;
    var lastFocus = null;
    var current = '';

    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }); }
    catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
    function money(v) {
      var n = parseFloat(v);
      return isNaN(n) ? '' : fmt.format(n);
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    // Bold the parts of `text` that start with any typed word.
    function highlight(text, q) {
      var safe = esc(text);
      var words = q.toLowerCase().split(/\s+/).filter(Boolean)
        .map(function (w) { return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      if (!words.length) return safe;
      var re = new RegExp('(^|[\\s\\-/(&;])(' + words.join('|') + ')', 'gi');
      return safe.replace(re, '$1<mark>$2</mark>');
    }
    function sizedImage(url, w) {
      if (!url) return '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      try {
        var u = new URL(url, document.baseURI);
        u.searchParams.set('width', w);
        return u.toString();
      } catch (e) { return url; }
    }

    /* ---------- open / close ---------- */
    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      // close the mobile menu drawer if it happens to be open
      var drawer = document.querySelector('[data-lv-drawer].is-open');
      if (drawer) { drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
      root.hidden = false;
      document.documentElement.classList.add('lv-search-open');
      // focus synchronously inside the tap so iOS raises the keyboard
      input.focus();
      if (input.value.trim()) run();
    }
    function close() {
      if (root.hidden) return;
      root.hidden = true;
      document.documentElement.classList.remove('lv-search-open');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-lv-search-open]');
      if (t) open(e);
    });
    root.querySelector('[data-lv-search-close]').addEventListener('click', close);
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') moveFocus(e);
    });

    function moveFocus(e) {
      var items = Array.prototype.slice.call(body.querySelectorAll('a.lv-sr, a.lv-search__all'))
        .filter(function (a) { return a.offsetParent !== null; });
      if (!items.length) return;
      var i = items.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') (i < 0 ? items[0] : items[Math.min(i + 1, items.length - 1)]).focus();
      else if (i <= 0) input.focus();
      else items[i - 1].focus();
    }

    /* ---------- typing ---------- */
    input.addEventListener('input', run);
    clearBtn.addEventListener('click', function () {
      input.value = '';
      run();
      input.focus();
    });
    root.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('[data-lv-search-term]');
      if (!chip) return;
      input.value = chip.getAttribute('data-lv-search-term');
      run();
      input.blur(); // drop the phone keyboard so the results are visible
    });
    // Scrolling the results on a phone dismisses the keyboard.
    body.addEventListener('touchstart', function () { if (document.activeElement === input) input.blur(); }, { passive: true });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });

    function run() {
      var q = input.value.trim();
      clearBtn.hidden = !input.value;
      current = q;
      clearTimeout(timer);
      if (!q) {
        if (ctrl) ctrl.abort();
        root.classList.remove('is-loading');
        out.innerHTML = '';
        idle.hidden = false;
        return;
      }
      if (cache[q]) { render(q, cache[q]); return; }
      root.classList.add('is-loading');
      timer = setTimeout(function () { fetchResults(q); }, 110);
    }

    function fetchResults(q) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var params = [
        'q=' + encodeURIComponent(q),
        'resources[type]=product,collection',
        'resources[limit]=8',
        'resources[limit_scope]=each',
        'resources[options][unavailable_products]=last',
        'resources[options][fields]=title,product_type,variants.title,vendor,tag'
      ].join('&');
      fetch(suggestUrl + '?' + params, {
        headers: { Accept: 'application/json' },
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          var res = (data && data.resources && data.resources.results) || {};
          cache[q] = res;
          if (q === current) render(q, res);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (q === current) renderError(q);
        });
    }

    /* ---------- rendering ---------- */
    function productRow(p, q) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      var price = parseFloat(p.price);
      var compare = parseFloat(p.compare_at_price_max);
      var priceHtml = money(p.price);
      if (compare > price) priceHtml += '<s>' + money(compare) + '</s>';
      if (p.available === false) priceHtml += '<span class="lv-sr__soldout">Sold out</span>';
      return '<li><a class="lv-sr" href="' + esc(p.url) + '">' +
        '<span class="lv-sr__img">' + (img ? '<img src="' + esc(sizedImage(img, 160)) + '" alt="" width="80" height="80">' : '') + '</span>' +
        '<span class="lv-sr__txt">' +
          (p.vendor ? '<span class="lv-sr__brand">' + esc(p.vendor) + '</span>' : '') +
          '<span class="lv-sr__title">' + highlight(p.title, q) + '</span>' +
          '<span class="lv-sr__price">' + priceHtml + '</span>' +
        '</span></a></li>';
    }

    function render(q, res) {
      root.classList.remove('is-loading');
      idle.hidden = true;

      var products = (res.products || []).filter(function (p) { return parseFloat(p.price) > 0; });
      var collections = (res.collections || []).filter(function (c) { return !HIDDEN_COLLECTION.test(c.handle || ''); }).slice(0, 4);
      var allUrl = searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      var html = '';

      if (products.length) {
        html += '<p class="lv-search__label">Products</p><ul class="lv-search__list">' +
          products.map(function (p) { return productRow(p, q); }).join('') + '</ul>';
      }

      if (collections.length) {
        html += '<p class="lv-search__label">Collections</p><div class="lv-search__chips">' + collections.map(function (c) {
          return '<a class="lv-chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        }).join('') + '</div>';
      }

      if (products.length) {
        html += '<a class="lv-search__all" href="' + esc(allUrl) + '">See all results for “' + esc(q) + '”</a>';
      } else {
        html += '<p class="lv-search__empty">No products match “' + esc(q) + '” yet.</p>' +
          '<p class="lv-search__label">Try</p><div class="lv-search__chips">' +
          Array.prototype.map.call(idle.querySelectorAll('[data-lv-search-term]'), function (b) { return b.outerHTML; }).join('') +
          '</div><a class="lv-search__quiz" href="/pages/skin-quiz">Not sure what to look for? <strong>Take the skin quiz &rarr;</strong></a>';
      }

      out.innerHTML = html;
      body.scrollTop = 0;
    }

    function renderError(q) {
      root.classList.remove('is-loading');
      idle.hidden = true;
      out.innerHTML = '<a class="lv-search__all" href="' +
        esc(searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') +
        '">Search for “' + esc(q) + '”</a>';
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
